import {getDate, scrollToChatBodyBottom, isRelativeUrl, live_agent_msg} from './chatGPTV2-assistant';

const env = window.getparam('env') || 'prod';



const streamUrl = `https://content.webapi-services.net/api/streaming/openai${env === 'dev' ? '?env=dev':''}`;
//const streamUrl = `https://content.webapi-services.net/api/streaming/openai?env=${env}`;
let isMob = window.innerWidth < 768 && "ontouchstart" in document.documentElement ? true : false;

export let answer_time;

let hi_en = languageAttributes.languageCode === 'hi' && languageAttributes.spokenLanguageCode === 'en';


function formatToHTML(text) {

    let replacedText = text.replace(/【[^】]*】/g, '')
    .replace(/<br\s*\/?>\s*(?=<li>)/g, '')
    .replace(/<\/li>\s*<br\s*\/?>/g, '</li>')
    .replace(/<ul>\s*<br\s*\/?>/g, '<ul>')
    .replace(/<br\s*\/?>\s*<\/ul>/g, '</ul>')
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
    .replace(/\\"/g, '"')   
    .replace(/\n/g, '<br>');


    return replacedText;
}


export async function fetchAndStream(q, l,threadId) {

    let query = {
        input: decodeURIComponent(q),
        lang: l
    }

    if(threadId){query.threadId = threadId}

    const response = await fetch(streamUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // Add any other headers you need here
            },
            body: JSON.stringify(query) // or use the appropriate format for your data
        });
    
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    
   
    const res1 = response.clone();
    const res2 = response.clone();

    const reader = res1.body.getReader();
    const decoder = new TextDecoder('utf-8');
    const outputDiv = document.querySelector('.pending-answer');
    let typing = document.querySelector('.typing');
    answer_time = getDate();

    let answer = "";
    let hi_answer = "";

    if ( isMob ) {

        const rect = outputDiv.getBoundingClientRect();
        const scrollTop = document.documentElement.scrollTop;
        const elementTop = rect.top + scrollTop;
/*
        window.scrollTo({
            top: elementTop - 120,
            behavior: 'smooth'
        });
*/
        
    }



    // Function to process each chunk
    function processChunk({ done, value }) {

        let typing = document.querySelector('.typing');


        if (done) {
            console.log("Stream complete");
            return res2.text();
            
        }

        // Decode and display the chunk
        const chunkText = decoder.decode(value, { stream: true });


        if(chunkText.includes('No thread found')) {
                return chunkText;
        }else{
       
            try {
                // answer += chunkText;
                let data_array;
                
                data_array = JSON.parse(`[${chunkText.replace(/}\s*{/g, '},{')}]`);
                data_array.forEach(data => {
                    if (data.type === "messageDelta") {
                        answer += data.data;
                        
                        if( l !== 'hi-en2' && l !== 'lm' && l !== 'arab'){
                            outputDiv.innerHTML =  formatToHTML(answer);
                        }else{
                            
                            if ( answer.includes(`html":"`) && !answer.includes(`"q`)) {
                                
                                hi_answer += data.data;
                                hi_answer = hi_answer
                                .replace(/":"/g, "")
                                .replace(/","/g, "")
                                .replace(/\\n/g, "<br/>")
                                .replace(/【[^】]*】/g, '')
                                if (typing) { typing.style.display = 'none'; }
                                outputDiv.innerHTML =  hi_answer;
                                scrollToChatBodyBottom();
                            }else if (answer.includes(`"action":"Live-agent"`)){
                                //outputDiv.innerHTML =  live_agent_msg;
                                //scrollToChatBodyBottom();
                            }

                            
                        }
                    }

                });

            } catch(x) {
            //console.log(x);
            }

            // Continue reading the stream
            typing && typing.remove(); 
            return reader.read().then(processChunk);

        }
    }

    

    const result = await reader.read().then(processChunk);

    return result;

   
}






